'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoEye = function GoEye(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5c-7.5 0-16.2 5-20 15 3.8 7.5 11.3 12.5 20 12.5s16.3-5 20-12.5c-3.7-10-12.5-15-20-15z m0 25c-7.5 0-13.7-5-15-10 1.3-5 7.5-10 15-10s13.8 5 15 10c-1.2 5-7.5 10-15 10z m0-17.5c-0.8 0-1.5 0.2-2.2 0.4 1.3 0.5 2.2 1.8 2.2 3.4 0 2-1.7 3.7-3.7 3.7-1.6 0-2.9-0.9-3.4-2.2-0.2 0.7-0.4 1.4-0.4 2.2 0 4.1 3.4 7.5 7.5 7.5s7.5-3.4 7.5-7.5-3.4-7.5-7.5-7.5z' })
        )
    );
};

exports.default = GoEye;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/eye.js
// module id = 1701
// module chunks = 0